import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogPresets } from '@principle-theorem/ng-shared';
import { IBridgeIntegration } from '@principle-theorem/principle-bridge-core';
import { IBridgeDevice } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import {
  BridgeDeviceSelectorDialogComponent,
  IBridgeDeviceSelectorDialogData,
} from './bridge-device-selector-dialog.component';

@Injectable()
export class BridgeDeviceSelectorService {
  constructor(private _dialog: MatDialog) {}

  async selectDevice(
    integration: IBridgeIntegration
  ): Promise<WithRef<IBridgeDevice> | undefined> {
    const config = DialogPresets.small<IBridgeDeviceSelectorDialogData>({
      data: { integration },
    });

    return this._dialog
      .open<
        BridgeDeviceSelectorDialogComponent,
        IBridgeDeviceSelectorDialogData,
        WithRef<IBridgeDevice>
      >(BridgeDeviceSelectorDialogComponent, config)
      .afterClosed()
      .toPromise();
  }
}
